
import React, { useState, useEffect } from "react";
import {Link} from 'react-router-dom'
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { PageTitle } from "../../../../../_template/layout/core/PageData";
import { toAbsoluteUrl } from "../../../../../_template/helpers/CommonFunction";
import SAISVG from "../../../../../_template/helpers/CommonFunction";

const Concepts = () => {
  const loginUserType = localStorage.getItem('type');

  let pageTitle
  if(loginUserType === 'A'){
    pageTitle = [
      {
        title: 'Agents',
        path: '/agents',
        isSeparator: false,
        isActive: false,
      },
      {
          title: '',
          path: '',
          isSeparator: true,
          isActive: false,
      },
      {
        title: 'Guide',
        path: '/guide/overview',
        isSeparator: false,
        isActive: false,
      },
      {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
      },
    ];
  }
  else if(loginUserType === 'D'){
    pageTitle = [
      {
        title: 'Agents',
        path: '/agents',
        isSeparator: false,
        isActive: false,
      },
      {
          title: '',
          path: '',
          isSeparator: true,
          isActive: false,
      },
    ];
  }


  
  const guideImgArr = [
    { src: toAbsoluteUrl('saiFile/guide/img_1.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_2.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_3.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_4.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_5.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_6.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_7.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_8.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_9.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_10.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_11.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_12.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_13.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_14.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_15.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_16.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_17.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_18.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_19.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_20.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_21.png') },
    { src: toAbsoluteUrl('saiFile/guide/img_22.png') },
  ];
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);


  useEffect(() => {
    const links = document.querySelectorAll(".sidebar-link");
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("data-bs-target").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 100,
            behavior: "smooth",
          });
        }
        links.forEach((l) => l.classList.remove("guide-active"));
        link.classList.add("guide-active");
      });
    });
    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", () => {});
      });
    };
  }, []);
  
  return (
    <>
      <PageTitle breadcrumbs={pageTitle}>Concepts</PageTitle>
      <style>
        {`
          .yarl__container {
            background-color: #00000099 !important;
            backdrop-filter: blur(3px) !important;
          }
          .yarl__navigation_next {
            display: none !important;
          }
          .yarl__navigation_prev {
            display: none !important;
          }
          .guide-active span {
            color: var(--sai-text-primary) !important;
          }
          .side-custom-bg {
            background: #f7fafe !important;
          }
        `}
      </style>
      <div className="row">
        <div className="col-md-9 col-12">
          <div className="card card-flush border">
            <div className="card-header mt-5">
              <div className="card-title align-items-start flex-column">
                <h2 className="card-label fw-bold text-gray-800 fs-3x mb-4">
                  Concepts
                </h2>
                <span className="text-gray-800 mt-2 fw-bold fs-1x mb-4 ">Users from all channels</span>
              </div>
            </div>
            <div className="card-body pt-2">
              <div id="keyconcept" className="flex-grow-1 my-3">
                <a className="text-gray-800 mb-6 fs-1 fw-bold lh-0">
                  Key Concepts to Understand
                </a>
                <span className="text-gray-800 fw-semibold d-block fs-6 mt-6">
                  Before you start, here are the key concepts to understand.
                </span>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                  Products & Features
                </h4>
                <p className="text-gray-800 fs-5 fw-bold ms-6 mb-6 mt-2 lh-lg">
                  Product and features are used when the customer has to make a choice between multiple options to get the actual information or the service that she wants. 
                </p>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6">
                    <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      Products are the offerings of your business. They can be physical products or service offerings. If you are a Car manufacturing company, the Products can be the models of your car. For example, if you are making an agent for Toyota, the products can be Innova, Hyryder, Hycross, Fortuner, Glanza and so on. If you are making an agent for a Hotel, the products can be Accommodation, Restaurant, Banquet, Conference and so on. If you are making an agent for an educational institution, the products can be Student Programs, Faculty, Executive Programs, Research and so on.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6">
                    <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Features are what the customers would want to know about your product. For example, for Toyota, the features can be Price, Engine Type, Mileage, Seating Capacity, Boot Space, BHP, Engine and so on. For a Hotel, the features can be, Room Type, Price, Room Size and so on. For an Educational Institutions, the features can be Eligibility, Fee, Academic Calendar, Class Size and so on.
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                  Services & Attributes
                </h4>
                <p className="text-gray-800 fs-5 fw-bold ms-6 mb-6 mt-2 lh-lg">
                  Services & Attributes are used when you have to collect some specific information from the Customer before you will be able to provide a service such as completing a sales request or taking a customer support request and so on. 
                </p>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6">
                    <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                        Services are where you provide a Service to the customer. For example, for Toyota, services can be Book a Vehicle, Inquire Delivery, Book Service and so on. For a Hotel, it can be Booking a Room, Reserve a Table, Book a Cab and so on. For an Educational Institution it can be Inquire Application Status, Pay Fee, Submit an Application and so on.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      Attributes are the information that the agent has to collect before it can complete the Service request. For example, for booking a service request at Toyota, the agent has to collect the Vehicle Number, Pickup Address, Date and Time of Pickup and so on. For booking a room at a Hotel, the attributes required can be Name, Number of Guests, Date of Arrival, Number of Days to Book, Payment Details and so on. For filling out an application at the Educational Institute, the attributes can be Name, Age, Gender, Academic Details and all that goes in a typical Admission form.
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold my-5 mb-6">
                  Action
                </h4>
                <p className="text-gray-800 fs-5 fw-bold ms-6 mb-10 mt-3 lh-lg">
                  Actions are what the agent will perform to fulfill the Customer request. It can be providing some information, or completing a sale, or taking a support request, or booking a cab and so on. There are also some default actions that are in-built, which work to bridge any breaks or unexpected shifts in the conversation. These are called Bridge Actions, which occur by default.
                </p>
                <p className="text-gray-800 fs-5 fw-bold ms-6 mb-10">
                  <span className="bg-light-dark p-2 px-5 rounded">
                    There are five types of Actions you can create with TruVoice.ai
                  </span>
                </p>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                        <span className="fw-bolder text-gray-700">Information actions:</span> These are simple responses for a given query. For example, the Customer may ask “Are you an agent?” The agent may respond, “Yes, I am your agent from XX business ready to serve you.” Another example can be, “Where is your office located at?” The agent can respond with the address.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      <span className="fw-bolder text-gray-700">Product & Feature Actions:</span> Product & Feature Actions: These are actions where the Customer has to choose from multiple options before the agent can provide the right response. For example, the customer may ask, “I am looking to buy a car”. The agent may have to ask, “What type of car? A hatchback, sedan, SUV, or MUV?” This is necessary for the agent to be able to provide the appropriate response. Now, the customer may say a sedan. And the company offers 3 variants of sedan. The agent may ask, “Which model would you like to see: sedan 1, sedan 2, or sedan 3. Based on what the Customer chooses, the agent may provide the appropriate response.
                    </div>
                  </div>
                  <p className="text-gray-800 fs-5 fw-bold mb-5 mt-3 lh-lg">
                    These are custom-built actions made by the developer. You can make any product and make any feature. However, please make sure that they are logical by design.
                  </p>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      <span className="fw-bolder text-gray-700">Service actions:</span> Continuing with the example of buying a Car, let’s say the Customer chooses sedan 3. The agent provides the information about sedan 3 and offers to make a booking. If the customer wants to make a booking right away, the agent needs to collect the details about the Customer and also possibly collect the booking amount. The agent has to collect the Name, Address, Contact Number, ID proof and then ask for payment of the Booking amount. It can collect the Card Number, CVV, Expiry Date and call the Payment gateway to collect the amount. Or the Customer can make payment outside the agent and provide the reference number. The agent has to collect these sets of information, sometimes validate the information, such as checking that the email and phone are accurate, payment details are correct and so on. Without all this, the agent will not be able to complete the Booking a Car request.
                    </div>
                  </div>
                  <p className="text-gray-800 fs-5 fw-bold mb-5 mt-3 lh-lg">
                    These are custom built actions made by the developer. You can make any Service and make any Attribute. However, please make sure that they are logical by design.
                  </p>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      <span className="fw-bolder text-gray-700">General actions:</span>There are a host of General actions that are pre-trained in TruVoice. These are Greeting, Pause, Handover and so on. You can simply select which of these General Actions you would like to add to your agent.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      <span className="fw-bolder text-gray-700">Handover actions:</span>This is when the Customer requests the conversation to be transferred to a human agent. When you initiate this action, you have to use the built-in API to redirect the conversation to another point.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      <span className="fw-bolder text-gray-700">Bridge actions (in-built):</span> Bridge actions trigger when unexpected turns happen in a Conversation mimicking human interactions. For example, a Customer is in the process of Booking a Car to buy, and he has provided his name and address. The agent has then asked for payment information. The customer has a query here on waiting time. The agent answers the waiting time and then resumes the conversation from asking for the payment information. Similarly, the customer makes a request that is out of scope or not understood by the agent. The agent will automatically say, “Sorry, I did not get this. Can you rephrase your query or select from the below options (Book a Car, Book a Service, Call Support)?"
                    </div>
                  </div>
                  <p className="text-gray-800 fs-5 fw-bold mt-3 mb-6 lh-lg">
                    The developer need not invoke these actions as they are built-in. However, the developer can provide the Response that the agent should say.
                  </p>
                </div>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                  Examples
                </h4>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      Whenever you create an action, you have to provide at least one example of how you expect your customer to make a request. For example, for Toyota, when making a Book a Car action, you expect the Customer to say, “I want to make a booking for Innova”.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      TruVoice.ai uses this example to auto-generate several similar expressions of intent, and that data will be used to machine-train your agent.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      There may be domains where TruVoice.ai may not have ready support for auto-generation. You may request our team to provide support in such cases or you may provide your own example in a specified format, which can be used to train your agent.
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                  Response
                </h4>
                <p className="text-gray-800 ms-6 fs-5 fw-bold mb-10 mt-3">
                  Responses are agent responses to your Customer queries.
                </p>
                <p className="text-gray-800 fs-5 fw-bold ms-6 mb-10">
                  <span className="bg-light-dark p-2 px-5 rounded">
                    The types of Responses are:
                  </span>
                </p>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      Static responses are pre-specified responses to a query.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    DB responses are responses fetched from a certain DB that you may have. You have to integrate a DB query with the pre-defined API format. 
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      API responses are from any other system such as a CRM or a Generative AI application. You have to integrate the API with our predefined API endpoint.
                    </div>
                  </div>
                </div>
                <p className="text-gray-800 fs-5 fw-bold ms-6 mb-10">
                  <span className="bg-light-dark p-2 px-5 rounded">
                    The parts of Responses are:
                  </span>
                </p>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      Initial Response – This is something like, “I understand that you would like to book a room”.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Main Response – This is something like, “May I know in whose name should I book the room?” 
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      Fail case Response – This is applicable when DB or API queries are used. For example, the agent checks the availability of rooms and says, “Sorry, there are no rooms available on those dates.”
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                  Action Name
                </h4>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      Every Custom Action you create, apart from the General Actions, will need a unique Action Name. You can use this as a reference.
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                  Follow-up Actions
                </h4>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      These are actions that are to be called after completing another response. For example, in Toyota, someone has asked for information about Hyryder. The agent has provided all the information. Then, without the Customer prompting, the agent can offer to Book a Hyryder by asking, “Would you like to book a Hyryder now?”
                      <span className="mt-3 d-block">
                        You can select such follow-up actions at the end of any other action. The follow-up action will be triggered after the Customer-requested action is completed. Note that you can add any action as a follow-up only if it is already created by you.
                      </span>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-grow-1 mb-5">
                <a className="text-gray-800 fs-1 fw-bold mb-6">
                  Step-by-step Guidance
                </a>
              </div>
              <div className="mb-10">
                <h4 className="text-gray-800 fw-bold mb-10">
                  1. Follow-up Actions
                </h4>
                <div className="row mt-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[0].src}
                      onClick={() => { setOpen(true); setCurrentIndex(0) }}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-10">
                <h4 className="text-gray-800 fw-bold mb-8">
                  2. Dashboard
                </h4>
                <div className="my-2 ms-10">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      Upon signing in, you should see your Dashboard. It will show all your projects along with the status of the agent. You can click on any agent to start editing or other actions.
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[1].src}
                      onClick={() => { setOpen(true); setCurrentIndex(1) }}
                    />
                  </div>
                </div>
              </div>
              <div id="createagent" className="mb-10">
                <h4 className="text-gray-800 fw-bold mb-10">
                  3. Create Virtual Assistants
                </h4>
                <div className="row mt-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[2].src}
                      onClick={() => { setOpen(true); setCurrentIndex(2) }}
                    />
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center my-10">
                    <div className="text-gray-800 fw-semibold fs-5">
                      Click on Virtual Agent to create your agent
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[2].src}
                      onClick={() => { setOpen(true); setCurrentIndex(2) }}
                    />
                  </div>
                </div>
                <div className="my-8 ms-6">
                  <div className="d-flex align-items-center mt-10">
                    <div className="text-gray-800 fw-semibold fs-5">
                      Select an agent name for your new agent. Please note:
                    </div>
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      You cannot create two agents with the same name.
                    </div>
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                      If you create the same agent for different channels, like one for Web Chat and another for WhatsApp, you may name them Serviceagent_Web and Serviceagent_Whatsapp, for example.
                    </div>
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      Description is optional for your own reference. Note that your Customers who will interact with the agents you create do not see the description.
                    </div>
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      You select Channel and Language from the drop-down. In case the Channel you prefer does not show here, you may drop us an email at techsupport@truvoice.ai for our team to consider if we can add it in the next version.
                    </div>
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      Once you save, a record for your agent is created. And you can move on to making the actual agent.
                    </div>
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      Before proceeding further, you should understand how to Design an agent on TruVoice.ai here.
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8">
                <h4 className="text-gray-800 fs-1 fw-bold mb-6">
                  Information Action
                </h4>
                <p className="text-gray-800 ms-6 fs-5 fw-bold mt-3 mb-6 lh-lg">
                  Use this Action Type when you want to provide simple information to queries, typically like FAQ queries, which do not require the customer to provide further specifications. For example, if someone asks, “What is the return policy?”, “Do you supply in the US?”, “What are the side effects of using your product?”, etc.
                </p>
                <p className="text-gray-800 ms-6 fs-5 fw-bold mb-10 mt-3">
                  You should use one separate (Actions) for each Information item that you want your agent to answer to.
                </p>
                <p className="text-gray-800 fs-5 fw-bold ms-6 mb-10">
                  <span className="bg-light-dark p-2 px-5 rounded">
                    Here is the explanation of each field in creating an Information Action
                  </span>
                </p>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                        <span className="fw-bolder text-gray-700">Information Item:</span> Information Item: This is what the information is about. It can be “Weather” or “Return Policy” or “Swimming Pool” or so. Think of giving a name to each of the typical FAQs that you want to provide answers to.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      <span className="fw-bolder text-gray-700">Add Example:</span>This is an example of how your customer would ask about this information. For example, you may write an example as “What is the weather today?” or “How is the weather today?” 
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-10">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs051.svg" className="svg-icon-10 me-3" />
                      <span className="fw-bolder text-gray-800">TruVoice.ai</span> uses the example you provide to auto-generate more of such question sentences and auto-train an NLU model for your agent. 
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-10">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs051.svg" className="svg-icon-10 me-3" />
                      You need to provide at least one example. 
                    </div>
                  </div>
                </div>
                <div className="my-2 ms-6">
                  <div className="d-flex align-items-center mb-6 lh-lg">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                        <span className="fw-bolder text-gray-700">Select Response Type:</span> (Responses) As of now, select the response as static because the others are not implemented yet.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 ms-10">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <span className="fw-bolder text-gray-700">Responses:</span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-20">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs048.svg" className="svg-icon-9 me-3 text-gray-800" />
                      You can use <span className="fw-bolder text-gray-800">Initial Response</span> to acknowledge the query. For example, “Ok, I understand it.” Or “Let me look it up for you.” 
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-20">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs048.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                        <span className="fw-bolder text-gray-700">Final Response</span> is the main response for the query.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-20">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs048.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                        <span className="fw-bolder text-gray-700">Fail Response</span> is when you cannot provide an answer to the query. For example, it is outside your scope, or it is not a valid question, or you do not have the relevant answer to the query.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-10">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-4 me-3" />
                      <span className="fw-bolder text-gray-700">Action Name:</span> This is the name you will identify your action with. You can name something like “Weather_info” or “Pool_info” and so on. It is preferable to use an action name that intuitively identifies with the Information Query.
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-10">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-4 me-3" />
                      <span className="fw-bolder text-gray-700">Follow-up Action (FU Action):</span> This is when you would like the agent to take the initiative to ask any leading questions. For example, after someone has asked if you have a Swimming Pool, you may want to follow it up with, “Would you like to know the timings?” or “Would you like to book a time?”
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-10">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <span className="fw-bolder text-gray-700">Opt-in</span> activates a question before initiation of a Follow-up Action. For example, “Would you like to know about the timings of the Swimming Pool?”. The FU triggers only if the customer opts in by saying “Yes”.
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-1"></div>
                    <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                      <img 
                        className="w-100 cursor-pointer" 
                        alt="Logo"
                        src={guideImgArr[3].src}
                        onClick={() => { setOpen(true); setCurrentIndex(3) }}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-10 mt-10">
                    <div className="text-gray-600 fw-semibold fs-6">
                      <span className="fw-bolder text-gray-700">Closing Utterance</span> is if you would like to provide a conclusive statement such as, “Thank you for your inquiry today, I will be right here if you need anything.”
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-1"></div>
                    <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                      <img 
                        className="w-100 cursor-pointer" 
                        alt="Logo"
                        src={guideImgArr[4].src}
                        onClick={() => { setOpen(true); setCurrentIndex(4) }}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-6 lh-lg ms-10 mt-10">
                    <div className="text-gray-800 fw-semibold fs-6">
                      <span className="fw-bolder text-gray-700">Feedback</span> is a very specific type of Action in which you can collect the User Feedback. This Action is not made available yet.
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-1"></div>
                    <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                      <img 
                        className="w-100 cursor-pointer" 
                        alt="Logo"
                        src={guideImgArr[5].src}
                        onClick={() => { setOpen(true); setCurrentIndex(5) }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div id="createinfoitem" className="mb-8">
                <h4 className="text-gray-800 fw-bold mb-10">
                  4. Create Information Items
                </h4>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[6].src}
                      onClick={() => { setOpen(true); setCurrentIndex(6) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 mt-10 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Click the Add button after providing the full details.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    You can add as many responses as you want.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 ms-6">
                  <div className="text-gray-600 fw-semibold fs-6">
                    <span className="text-gray-800 fw-bold mb-10">Product/Feature Action:</span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    Use Product Feature Action when you want to provide Product or Service specific information to your customers. For more details, (Product & Feature Actions)
                  </div>
                </div>
              </div>
              <div id="createproduct" className="mb-8">
                <h4 className="text-gray-800 fw-bold mb-10">
                  5. Create Product
                </h4>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[7].src}
                      onClick={() => { setOpen(true); setCurrentIndex(7) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg mt-10 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Click the Add button after providing the full details.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">Add Product:</span> You can add all the Products/Services which you deal in here. For example, if you are selling computers, you may add products such as “Laptops, Desktops, Printers, Accessories” etc. If you are a Hotel, you can add services such as “Room reservations, Restaurant, Banquet Hall, Conference Room etc.”
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">Add Product Synonyms:</span> Note that customers also use different synonyms interchangeably. For example, to inquire for a Laptop, they may also ask for a - Notebook or MacBook. Instead of Room Reservation, they may say Room Booking. If you add all such synonyms, which can also be acronyms, TruVoice.ai will train itself to understand the synonyms and respond accordingly.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-20">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs051.svg" className="svg-icon-10 me-3" />
                    <span className="fw-bolder text-gray-700">However, use only simple and unique synonyms</span> Overstretching this feature may result in overlapping synonyms with other Products/synonyms leading to performance errors of the agent.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                      After adding each synonym click on <span className="fw-bolder text-gray-700">Enter</span> button every time to save.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Click the Add button to save the Product and Synonyms.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-10 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    You can repeat to add as many Products/Services as you may want.
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[8].src}
                      onClick={() => { setOpen(true); setCurrentIndex(8) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mt-10 mb-10 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    You can see all the Products you have created in the Table below the section.
                  </div>
                </div>
              </div>
              <div id="createfeature" className="mb-8">
                <h4 className="text-gray-800 fw-bold mb-10">
                  6. Create Feature
                </h4>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[9].src}
                      onClick={() => { setOpen(true); setCurrentIndex(9) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mt-10 mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Add Feature: Add all the features of the Product/Service that your customers may be interested to know about. Some examples are Price, Specifications, Variants such as type of rooms or laptop models and so on.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Add Synonyms just like you have added for Product.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Click the Add button to save the Features and their Synonyms.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    Repeat the cycle to add as many features as you want.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6 mt-8">
                  <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                    <div className="d-flex flex-column">
                      <h4 className="mb-1 text-primary mb-4">
                        NOTE:
                      </h4>
                      <span>You may use the same Features for different products. For example, Price can be used across all the products. But Guarantee can be used only in some products. You may match or associate different combinations in the next step. Therefore, keep your Features unique and do not repeat, unless there is a specific purpose.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div id="productfeatureassociation" className="mb-8">
                <h4 className="text-gray-800 fw-bold mb-10">
                  7. Create Product Feature Association
                </h4>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[10].src}
                      onClick={() => { setOpen(true); setCurrentIndex(10) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mt-10 mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    {/* <FontAwesomeIcon icon={faCircleDot} className="text-gray-800 me-3" /> */}
                    You can see all the Products and Features you have created in the Table below the section.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    {/* <FontAwesomeIcon icon={faCircleDot} className="text-gray-800 me-3" /> */}
                    The Next Step is to associate relevant features to the Products.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">Product Feature Association:</span> You can select created Features from the drop-down above and make relevant associations with the Product. 
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">
                      Once you save the Associations, they will display in the Table as below:
                    </span>
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[11].src}
                      onClick={() => { setOpen(true); setCurrentIndex(11) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center ms-6 mt-10">
                  <p className="text-gray-800 fs-5 fw-bold mb-10">
                    <span className="bg-light-dark p-2 px-5 rounded">
                      Click on next
                    </span>
                  </p>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <span className="fw-bolder text-gray-700">
                      Adding Actions to the Product Feature Associations:
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    For each Product Feature association, you need to provide a Response to the customer and give a unique Action Name.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    Rest of the Steps are same as those in Information Action.
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[12].src}
                      onClick={() => { setOpen(true); setCurrentIndex(12) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    Now select the association for each product and feature for the response you want to provide.
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[13].src}
                      onClick={() => { setOpen(true); setCurrentIndex(13) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center ms-6">
                <div className="text-gray-800 fs-5 fw-bold my-6">
                  <span className="bg-light-dark p-2 px-5 rounded">
                      Add them
                    </span>
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[14].src}
                      onClick={() => { setOpen(true); setCurrentIndex(14) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mt-10 mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    You can see all the Products and Features associations that you have created in the Table below the section.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 ms-6">
                  <div className="fs-5">
                    <span className="fw-bolder text-gray-800">
                      Service Action
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6"><div className="text-gray-800 fw-semibold fs-6">Use Service Action when you have to collect very specific information to fulfill a service request. Such as Booking a Cab, or Making a Purchase or Tracking a Purchase and so on. For more details, (Service actions page 2)</div></div>
                <div className="d-flex align-items-center mb-2 ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    Adding a Service and its synonyms is the same as Adding a Product and its synonyms.
                  </div>
                </div>
              </div>
              <div id="createservice" className="mb-8">
                <h4 className="text-gray-800 fw-bold mb-10">
                  8. Create Service
                </h4>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[15].src}
                      onClick={() => { setOpen(true); setCurrentIndex(15) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    After that, adding Attributes and synonyms is the same process as adding Features and synonyms in Product Feature Actions. Follow-up details are to be added only once that would be applied for service actions.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                    <div className="d-flex flex-column">
                        <h4 className="mb-1 text-primary mb-4">
                          NOTE:
                        </h4>
                        <span>For example, if you attribute a mobile number and the service you provide is to buy clothes and track order and want to mention the mobile number in agent services, then you do not require to add the same attribute two times. You can associate the same attribute for agent the services in next sessions.</span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    Therefore, for each Attribute the agent tries to fill in, you may require Validation.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">Validation type:</span> Select mandatory or optional as per your agent design. Attributes are different from Features, as the customer selects the Features, but she provides information about an Attribute.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    For example, if your customer wants to Track a Purchase, she has to provide the Order Number, which is an attribute. When the agent asks for the Order Number, the customer should provide a valid order number.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">Confirmation required:</span> This is if you want to confirm the information that the customer has provided. For example, the Customer provides the Order Number as “T2467”. You may want the agent to confirm it with the customer by asking, “The Order Number you provided is T2467. Can you confirm if this is correct?”
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">Data Type:</span> For each Attribute, select what kind of Data you are expecting. For example, if the Order Numbers in your company are alphanumeric, you select such a data type. If you are asking someone’s name, you can use String. And so on.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-8 ms-6">
                  <div className="alert alert-primary d-flex align-items-center p-5 w-100 border-none">
                    <div className="d-flex flex-column">
                      <h4 className="mb-1 text-primary mb-4">
                        NOTE:
                      </h4>
                      <span>
                        Data types provided are
                        <div className="d-flex align-items-center  mb-6 lh-lg my-4 ms-5">
                          <div className="text-primary fw-semibold fs-6">
                            <span className="fw-bolder text-primary">String:</span> It is used when alpha numerical, alpha numerical sequence, alphabet values are provided. Example: “shirt rate is 45$”, “We provide cotton t-shirts”.
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-6 lh-lg ms-5">
                          <div className="text-primary fw-semibold fs-6">
                            <span className="fw-bolder text-primary">Float:</span> It is used when “. “Is provided. Example 10.5$.
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-6 lh-lg ms-5">
                          <div className="text-primary fw-semibold fs-6">
                            <span className="fw-bolder text-primary">Integer:</span> It is used when numerical values are provided. Example: “10”, “789”.
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-680 fw-semibold fs-6">
                    Depending on the different data types, you may add further validation rules.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                    <span className="fw-bolder text-gray-700">Max attempts:</span> This the maximum number of times the agent will attempt to collect the information if the validation fails.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    If the max attempts are exhausted, the agent will move on to the next question. 
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-primary fw-semibold fs-6">
                    What happens if there is no next Attribute of Property? 
                  </div>
                </div>
              </div>
              <div id="attributesetup" className="mb-10">
                <h4 className="text-gray-800 fw-bold mb-10">
                  9. Create Attribute Setup
                </h4>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[16].src}
                      onClick={() => { setOpen(true); setCurrentIndex(16) }}
                    />
                  </div>
                </div>
              </div>
              <div id="serviceattributeassociation" className="mb-8">
                <h4 className="text-gray-800 fw-bold mb-10">
                  10. Service Attribute Association
                </h4>
                <div className="row my-3 mb-10">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[17].src}
                      onClick={() => { setOpen(true); setCurrentIndex(17) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    Now, you can make Service and Attribute associations just like you did in the case of Product and Features. However, you can also find the details of Validation, Confirmation, Data Type, and Max Attempts in this table.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    To save the associations that you have made, click “SAVE ASSOCIATIONS” button.
                  </div>
                </div>
                <div className="row my-3 mb-10">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[18].src}
                      onClick={() => { setOpen(true); setCurrentIndex(18) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    Now, just like you did in Product Feature Actions, you can add the final step of making the Service Attribute Actions here.
                  </div>
                </div>
                <div className="row my-3 mb-10">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[19].src}
                      onClick={() => { setOpen(true); setCurrentIndex(19) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    You can see all the service association you have created in the Table below the section.
                  </div>
                </div>
              </div>
              <div id="generalaction" className="mb-8">
                <h4 className="text-gray-800 fw-bold mb-10">
                  11. Create General Actions
                </h4>
         
                <div className="d-flex align-items-center mb-6 ms-6">
                  <div className="fs-5">
                    <span className="fw-bolder text-gray-800">General Actions</span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    These are pre-built actions that you can add to your agent as you like. There are a host of General actions that are pre-trained in TruVoice. These are Greeting, Pause, Handover and so on. You can simply select which of these General Actions you would like to add to your agent.
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    You can select the Actions you want to use and follow the steps just like you did for previous actions.
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[20].src}
                      onClick={() => { setOpen(true); setCurrentIndex(20) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg mt-10 ms-6">
                <div className="alert alert-primary d-flex align-items-center p-5 border-none">
                    <div className="d-flex flex-column">
                      <h4 className="mb-1 text-primary mb-4">
                        NOTE:
                      </h4>
                      <span>that if you select multiple responses, the agent will use them in round-robin fashion. That is the next conversation, which may be the same customer or the different customer, will get the 2nd response.</span>
                    </div>
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-md-3"></div>
                  <div className="col-md-6 border border-dashed rounded border-gray-400 me-2 p-3">
                    <img 
                      className="w-100 cursor-pointer" 
                      alt="Logo"
                      src={guideImgArr[21].src}
                      onClick={() => { setOpen(true); setCurrentIndex(21) }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center my-10 ms-6">
                  <div className="text-gray-800 fs-5 fw-bold">
                    <span className="bg-light-dark p-2 px-5 rounded">Click on finished button</span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-6 lh-lg ms-6">
                  <div className="text-gray-800 fw-semibold fs-6">
                    You can navigate the pages and use Edit feature to Delete features as you need. Once you are ready, click the Submit button. TruVoice.ai will generate the entire agent for you while you sit back and relax. You will receive an email once your agent is ready.
                  </div>
                </div>
                <div className="d-flex align-items-center my-10 ms-6">
                  <div className="fs-6">
                    <span className="fw-bolder text-primary">
                      <Link to='#' onClick={(e) => e.preventDefault()}>To test the agent</Link>
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 ms-6">
                  <div className="text-gray-800 fs-5 fw-bold">
                    <span className="bg-light-dark p-2 px-5 rounded">To be added</span>
                  </div>
                </div>
                <div className="d-flex align-items-center my-10 ms-6">
                  <div className="fs-6">
                    <span className="fw-bolder text-primary">
                      <Link to='#' onClick={(e) => e.preventDefault()}>To deploy the agent</Link>
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 ms-6">
                  <div className="text-gray-800 fs-5 fw-bold">
                    <span className="bg-light-dark p-2 px-5 rounded">To be added</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card position-fixed fill-wd">
            <div className="card-body card-rounded px-0 px-6 py-6 side-custom-bg" bis_skin_checked="1" >
            <ul id="kt_sidebar_nav" className="nav nav-flush menu menu-column menu-title-gray-600 menu-bullet-gray-600 menu-state-primary fw-bold fs-6 mb-8">
              <li className="menu-item py-2">
                <button
                  type="button"
                  className="menu-link p-0 nav-link sidebar-link"
                  data-kt-scroll-toggle="true"
                  data-bs-target="#keyconcept"
                >
                  <span className="menu-title fw-semibold">Key Concepts</span>
                </button>
              </li>
              <li className="menu-item py-2">
                <button
                  type="button"
                  className="menu-link p-0 nav-link sidebar-link"
                  data-kt-scroll-toggle="true"
                  data-bs-target="#createagent"
                >
                  <span className="menu-title fw-semibold">Create Virtual Assistants</span>
                </button>
              </li>
              <li className="menu-item py-2">
                <button
                  type="button"
                  className="menu-link p-0 nav-link sidebar-link"
                  data-kt-scroll-toggle="true"
                  data-bs-target="#createinfoitem"
                >
                  <span className="menu-title fw-semibold">Create Information Items</span>
                </button>
              </li>
              <li className="menu-item py-2">
                  <button
                    type="button"
                    className="menu-link p-0 nav-link sidebar-link"
                    data-kt-scroll-toggle="true"
                    data-bs-target="#createproduct"
                  >
                    <span className="menu-title fw-semibold">Create Product</span>
                  </button>
              </li>
              <li className="menu-item py-2">
                <button
                    type="button"
                    className="menu-link p-0 nav-link sidebar-link"
                    data-kt-scroll-toggle="true"
                    data-bs-target="#createfeature"
                  >
                    <span className="menu-title fw-semibold">Create Feature</span>
                  </button>
              </li>
              <li className="menu-item py-2">
                <button
                    type="button"
                    className="menu-link p-0 nav-link sidebar-link"
                    data-kt-scroll-toggle="true"
                    data-bs-target="#productfeatureassociation"
                  >
                    <span className="menu-title fw-semibold">Product Feature Association</span>
                  </button>
                </li>
                <li className="menu-item py-2">
                  <button
                    type="button"
                    className="menu-link p-0 nav-link sidebar-link"
                    data-kt-scroll-toggle="true"
                    data-bs-target="#createservice"
                  >
                    <span className="menu-title fw-semibold">Create Service</span>
                  </button>
                </li>
                <li className="menu-item py-2">
                  <button
                    type="button"
                    className="menu-link p-0 nav-link sidebar-link"
                    data-kt-scroll-toggle="true"
                    data-bs-target="#attributesetup"
                  >
                    <span className="menu-title fw-semibold">Attribute Setup</span>
                  </button>
                </li>
                <li className="menu-item py-2">
                  <button
                    type="button"
                    className="menu-link p-0 nav-link sidebar-link"
                    data-kt-scroll-toggle="true"
                    data-bs-target="#serviceattributeassociation"
                  >
                    <span className="menu-title fw-semibold">Service Attribute Association</span>
                  </button>
                </li>
                <li className="menu-item py-2">
                  <button
                    type="button"
                    className="menu-link p-0 nav-link sidebar-link"
                    data-kt-scroll-toggle="true"
                    data-bs-target="#generalaction"
                  >
                    <span className="menu-title fw-semibold">Create General Actions</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[guideImgArr[currentIndex]]}
        currentIndex={currentIndex}
        carousel={{ finite: true }}
      />
    </>
  );
};

export default Concepts
